<template>
	<div class="vx-row">
		<div class="vx-col w-full mb-5">
			<vx-card>
				<h2 class="mb-4">
					{{ $t("activeOrders") }}
				</h2>

				<vs-table
					max-items="10"
					pagination
					:data="data"
					class="table-th-center"
				>
					<template slot="thead">
						<vs-th
							v-for="fil in tableFields"
              :key="fil.field"
							:class="{
								'justify-center':
									fil.align && fil.align === 'center',
								'text-center':
									fil.align && fil.align === 'center'
							}"
							:sort-key="fil.field"
							class="justify-center table-title"
						>
							{{ fil.title }}
						</vs-th>
					</template>

					<template slot-scope="{ data }">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<template v-for="fil in tableFields">
								<vs-td
									v-if="fil.field === 'order_id'"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									<template v-if="tr.order_id">
										<router-link
											:to="'/ticket/' + tr.order_id"
										>
											{{ tr.order_id }}
										</router-link>
									</template>

									<div v-else>
										---
									</div>
								</vs-td>

								<vs-td
									v-else-if="fil.field"
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									{{ tr[fil.field] }}
								</vs-td>

								<vs-td
									v-else
									:class="{
										'text-center':
											fil.align && fil.align === 'center'
									}"
								>
									...
								</vs-td>
							</template>
						</vs-tr>
					</template>
				</vs-table>
			</vx-card>
		</div>
	</div>
</template>

<script>
export default {
	name: "AuthorsActiveOrdersTable",

	props: {
		data: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			tableFields: [
				{
					field: "order_id",
					title: this.$t("orderId"),
					align: "center"
				},
				{
					field: "amount",
					title: `${this.$t("income")}, €`,
					align: "center"
				},
				{
					field: "manager",
					title: this.$t("manager"),
					align: "center"
				},
				{
					field: "website",
					title: this.$t("site"),
					align: "center"
				},
				{
					field: "date",
					title: this.$t("date"),
					align: "center"
				}
			]
		};
	}
};
</script>

<style></style>
